import React from "react";
import { withStyles, Theme, createStyles, LinearProgress, Card, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import { withRouter, RouteComponentProps } from "react-router-dom";
import  {SelfTimingEvent} from '../models/Event';
import {withTranslation, WithTranslation} from 'react-i18next';
import SelfTimingBackend from "../providers/SelfTimingBackend";
import moment from 'moment';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import EditEventDetails from "./EditEventDetails";

interface State {
    events : SelfTimingEvent[];
    isLoading:boolean;
    addEvent : SelfTimingEvent;
}

class MyEvents extends React.Component<React.Props<any>,State>{

    constructor(props : any) {
        super(props);
        this.state = {events:null, isLoading : true, addEvent : null};
        this.updateCourses();
    }

    updateCourses = () => {
        var back = new SelfTimingBackend();
        this.setState({isLoading: true});

        back.getMyEvents().then((events) => {
            this.setState({events: events,isLoading:false,addEvent:null})
        });
    }
    gotoEvent = (eventId : string) => () => {
        (this.props as any).history.push("/events/"+eventId);
    }

    confirmAddEvent = () => {
        var back = new SelfTimingBackend();
        back.addEvent(this.state.addEvent).then(() => {
            this.updateCourses();
        })
    }
    abortAddEvent = () => {
        this.setState({addEvent : null});
    }

    addEvent = () => {
        var ev = new SelfTimingEvent();
        this.setState({addEvent:ev});
    }

    newEventOnValueChange = (field : string, value : any) => {
        var s = this.state.addEvent;
        (s as any)[field] = value;
        this.setState(s as any);
    }

    renderAddEvent = () => {
        return this.state && this.state.addEvent != null ?<Dialog
        open={this.state.addEvent != null}
        onClose={this.abortAddEvent}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Ny tävling"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <EditEventDetails {...this.state.addEvent} onChange={this.newEventOnValueChange}/>            
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.abortAddEvent} variant="contained" color="primary">
            AVBRYT
          </Button>
          <Button onClick={this.confirmAddEvent} variant="contained" color="primary" autoFocus>
            SKAPA TÄVLING
          </Button>
        </DialogActions>
      </Dialog> : null;
    }
   
    render() 
    {
        const { classes,t } = this.props as any;
        return <div style={{padding:'5px'}}>          
            <div className={classes.tableHeader} style={{display: 'flex', padding:'3px 24px'}}>
            <div style={{flex:1}}><b>{t('COURSE_DATE')}</b></div>
            <div style={{flex:1}}><b>{t('COURSE_NAME')}</b></div>
            <div style={{flex:1}}><b>{t('COURSE_ORGANIZER')}</b></div>
            
            <div style={{flex:1}}></div>
        </div>
      
        {this.state.isLoading &&
            <LinearProgress  />
        }
        {this.state.events && this.state.events.map((event, idx) => {
            return <Card style={{display: 'flex', padding:'3px 24px', cursor: 'pointer', marginBottom: '3px'}} onClick={this.gotoEvent(event.Id)}>
                <div style={{flex:1, lineHeight: '22px'}}><b>{moment(event.Date).format("YYYY-MM-DD")}</b></div>
                <div style={{flex:1, lineHeight: '22px'}}><b>{event.Name}</b></div>
                <div style={{flex:1, lineHeight: '22px'}}><b>{event.Organizer}</b></div>
                
                <div style={{flex:1,lineHeight: '22px', textAlign: 'right'}}>Öppna tävling <ChevronRightIcon style={{verticalAlign:'middle'}} /></div>
                </Card>;
        })}

        <Button variant="contained" color="primary" onClick={this.addEvent}>Lägg till tävling</Button>
        {this.renderAddEvent()}
        </div>
    }

}

const useStyles = ({ palette, spacing }: Theme) => createStyles({
  
    tableHeader: {
        backgroundColor: palette.primary.light,
        color: 'white'
    },
    formControl: {
        
        margin: '3px',
        minWidth: 200,
      },
      cardHeader: {
        backgroundColor: palette.primary.main,
      },
        cardHeaderTitle: {
            fontSize: '12px',
            lineHeight: '12px'
        }
  
});
export default withStyles(useStyles)(withRouter(withTranslation()(MyEvents) as any));